const renderFxRate = ( () => {
    const render = (receiveAmountValue, strikedValue) => {
        const defaultFxTextTemplateEl = document.querySelector('.render-fx-rate-text');
        if (!defaultFxTextTemplateEl) {
            return;
        }

        const isRenderFxRateMounted = defaultFxTextTemplateEl.getAttribute('data-is-mounted') === 'true';
        if (isRenderFxRateMounted) {
            return;
        }

        let html = defaultFxTextTemplateEl.getAttribute('data-html') ?? defaultFxTextTemplateEl.innerHTML;
        if(!html) {
            return;
        }

        defaultFxTextTemplateEl.setAttribute('data-html', html);
        defaultFxTextTemplateEl.setAttribute('data-is-mounted', true);

        let renderFxRateTemplates = {
            receiver_amount: '{{receiver_amount}}',
            striked_receiver_amount: '{{striked_receiver_amount}}',
        };

        html = html.replace(renderFxRateTemplates.receiver_amount, receiveAmountValue);

        if (strikedValue !== receiveAmountValue) {
            html = html.replace(renderFxRateTemplates.striked_receiver_amount, `<strike class="text-red">${strikedValue}</strike>`);
        }
        
        //reset template
        html = html.replace(renderFxRateTemplates.receiver_amount, '');
        html = html.replace(renderFxRateTemplates.striked_receiver_amount, '');

        defaultFxTextTemplateEl.innerHTML = html;

        defaultFxTextTemplateEl.classList.remove('d-none');
    };
    return {
        render
    };
})();